import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=4fbca544&scoped=true&"
import script from "./Keyboard.vue?vue&type=script&lang=js&"
export * from "./Keyboard.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard.vue?vue&type=style&index=0&id=4fbca544&scoped=true&lang=css&"
import style1 from "./Keyboard.vue?vue&type=style&index=1&id=4fbca544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbca544",
  null
  
)

export default component.exports